export default __webpack_public_path__ + "text-size.asset.db079070cfa4ec4e811256b3035cd28f.svg";